module.exports = "<router-outlet></router-outlet>"


//////////////////
// WEBPACK FOOTER
// ./src/app/investigation-docs/investigation-docs.component.html
// module id = ./src/app/investigation-docs/investigation-docs.component.html
// module chunks = main